import { Outlet, useLocation } from "react-router-dom";
import { SidebarMobileTrigger, SidebarProvider } from "@/components/ui/sidebar";
import { StudentSidebar } from "./StudentSidebar";
import { useAuth } from "@/contexts/AuthContext";
import { OnboardingProvider } from "@/contexts/OnboardingContext";
import { SkipLink } from "@/components/ui/skip-link";

const StudentLayout = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return null;
  }

  const isOnChatPage = location.pathname === '/student/chat';

  return (
    <OnboardingProvider>
      <SidebarProvider>
        <SkipLink href="#main-content" />
        <div className="fixed left-3 top-3 z-40 md:hidden">
          <SidebarMobileTrigger aria-label="メニューを開く" />
        </div>
        <div className="flex h-dvh w-full bg-background">
          <StudentSidebar />
          <main
            id="main-content"
            className={`flex-1 bg-muted/30 ${isOnChatPage ? 'flex flex-col min-h-0 overflow-hidden' : 'p-6'}`}
            role="main"
            aria-label="メインコンテンツ"
            tabIndex={-1}
          >
            {isOnChatPage ? (
              <div className="flex flex-1 flex-col px-6 py-6 min-h-0 overflow-hidden">
                <Outlet />
              </div>
            ) : (
              <Outlet />
            )}
          </main>
        </div>
      </SidebarProvider>
    </OnboardingProvider>
  );
};

export default StudentLayout;
